export enum DataEntryStateEnum {
  Draft = 0,
  Active = 1,
  Archived = 2,
}
